import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useArchiveJob = () => {
  const { toast } = useToast();

  const archiveJob = async (jobId: string) => {
    try {
      const { error } = await supabase
        .from('jobs')
        .update({ archived_at: new Date().toISOString() })
        .eq('id', jobId);

      if (error) throw error;

      toast({
        title: "Job archived",
        description: "Job has been moved to archive.",
      });

      return true;
    } catch (error: any) {
      console.error('Error archiving job:', error);
      toast({
        title: "Error",
        description: error.message || "Failed to archive job",
        variant: "destructive",
      });
      return false;
    }
  };

  const unarchiveJob = async (jobId: string) => {
    try {
      const { error } = await supabase
        .from('jobs')
        .update({ archived_at: null })
        .eq('id', jobId);

      if (error) throw error;

      toast({
        title: "Job unarchived",
        description: "Job has been restored from archive.",
      });

      return true;
    } catch (error: any) {
      console.error('Error unarchiving job:', error);
      toast({
        title: "Error",
        description: error.message || "Failed to unarchive job",
        variant: "destructive",
      });
      return false;
    }
  };

  return { archiveJob, unarchiveJob };
};
